const MetricsState = {
    summary: [],
    dashboard: {
        users: []
    },
    getBalances: {},
    walletOverview: null
};

export default MetricsState;